import { Icon, IconButton, TextField, type TextFieldProps } from '@pm/ui';
import { useToggle } from '@pm/util';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const PasswordVisibilityField = forwardRef<
  HTMLInputElement,
  TextFieldProps
>((props, ref) => {
  const [showPassword, handlers] = useToggle(false);
  const { t } = useTranslation('core', {
    keyPrefix: 'components.passwordVisibility',
  });
  const label = t(showPassword ? 'showPassword' : 'hidePassword');

  return (
    <TextField
      {...props}
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      pattern="clickable"
      trailingIcon={
        <IconButton
          intent="ghost"
          onClick={handlers.toggle}
          aria-label={label}
          title={label}
          type="button"
          size="xSmall"
        >
          <Icon
            name={showPassword ? 'visibility' : 'visibility_off'}
            size="xl"
          />
        </IconButton>
      }
    />
  );
});

PasswordVisibilityField.displayName = 'PasswordVisibilityField';
